import React from "react";

const SOA = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_11285_4443)">
        <path
          d="M21 4V20"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M4.85001 19.5002H15.16C16.17 19.5002 17.01 18.6703 17.01 17.6503V15.3403C17.01 14.3203 16.18 13.4902 15.16 13.4902H4.85001C3.84001 13.4902 3 14.3203 3 15.3403V17.6503C3 18.6703 3.83001 19.5002 4.85001 19.5002Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
        />
        <path
          d="M8.85974 10.5002H15.1598C16.1698 10.5002 17.0098 9.67027 17.0098 8.65027V6.34027C17.0098 5.32027 16.1798 4.49023 15.1598 4.49023H8.85974C7.84974 4.49023 7.00977 5.32027 7.00977 6.34027V8.65027C7.00977 9.67027 7.83974 10.5002 8.85974 10.5002Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
        />
      </g>
      <defs>
        <clipPath id="clip0_11285_4443">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SOA;
